import { createElement, memo, useState } from '@max/max';
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import Sensor from '@max/mbc-sensor';
import './index.scss';
/**
 * 懒加载容器组件
 * 当组件进入视口时才渲染children，渲染后Sensor不再显示
 */
const LazyLoadContainer = (props) => {
    const { children, visibleThreshold = 1, checkVisibilityMode = 'full', height = 10 } = props;
    const ctx = useMonitorEngineContext();
    // 是否已经显示过
    const isInEditor = window && !!window.inEditor;
    const [isVisible, setIsVisible] = useState(isInEditor);
    // 当组件出现在视口中时触发
    const handleAppear = () => {
        ctx._LXReport.mvReport('b_daodian_lowcode_hi6u5bjg_mv');
        setIsVisible(true);
    };
    // 合并样式，添加高度
    const mergedStyle = {
        width: '100%',
        height: `${height}rpx`
    };
    // 直接通过条件判断返回不同的组件
    if (!isVisible) {
        return <Sensor visibleThreshold={visibleThreshold} checkVisibilityMode={checkVisibilityMode} onAppear={handleAppear} once={true} // 只触发一次
         style={mergedStyle}/>;
    }
    return children;
};
export default memo(LazyLoadContainer);
